import { Button, Icon } from '@chakra-ui/react';
import { HeartIcon, Squares2X2Icon, Bars3Icon } from '@heroicons/react/24/outline';
import { HeartIcon as HeartSolidIcon } from '@heroicons/react/24/solid';

export type ViewMode = 'list' | 'grid';

/**
 * "Favorites" filter toggle for list/library pages. Solid heart + red when
 * active. Shared list control; the caller owns the boolean state.
 */
export function FavoritesToggle({ active, onToggle }: { active: boolean; onToggle: () => void }) {
  return (
    <Button
      size='sm'
      variant='ghost'
      color={active ? 'danger' : 'fg.muted'}
      onClick={onToggle}
    >
      <Icon as={active ? HeartSolidIcon : HeartIcon} w={4} h={4} />
      Favorites
    </Button>
  );
}

/**
 * Grid/List view switch. Shows the label/icon for the view you'd switch TO.
 * The caller owns `mode` and performs the flip in `onToggle`.
 */
export function ViewToggle({ mode, onToggle }: { mode: ViewMode; onToggle: () => void }) {
  return (
    <Button colorPalette='brand' size='sm' variant='ghost' onClick={onToggle}>
      <Icon as={mode === 'list' ? Squares2X2Icon : Bars3Icon} w={4} h={4} />
      {mode === 'list' ? 'Grid View' : 'List View'}
    </Button>
  );
}
